/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { SupplierCompany } from '@app/suppliers/suppliers/supplier-company.model';
import { Type } from '@app/settings/types/types.model';
import { Contact } from '@app/shared/components/contact/contact.model';
import { BankAccount } from '@app/shared/components/bank-accounts/bank-account.model';

export class Supplier extends Model {
  id: number;
  name: string;
  type_id: number;
  type?: Type;
  note: string;
  active: boolean;
  companies: [SupplierCompany];
  contacts: Array<Contact>;
  bank_accounts: Array<BankAccount>;
  address: string;
  registration_number: string;
  vat_number: string;
  responsible_person: string;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.type) {
      this.type = new Type().deserialize(input.type);
    }
    if (input.companies) {
      this.companies = input.companies.map((supplierCompany: SupplierCompany) =>
        new SupplierCompany().deserialize(supplierCompany)
      );
    }

    if (input.bank_accounts) {
      this.bank_accounts = input.bank_accounts.map((bankAccount: BankAccount) =>
        new BankAccount().deserialize(bankAccount)
      );
    }

    return this;
  }
}
